export default "assets/images/logo-69a94d19.png";